import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import { fDummyFunction, GridDataColumn } from "./Action";
import {
  CmpTypographyField,
  CmpButtonKIcon,
  CmpInputField,
  CmpSelectArrField,
  CmpButton,
} from "../ToolBox/ToolBox";
import GCToggleSearch from "./GCToggleSearch";

import useMediaQuery from "@mui/material/useMediaQuery";

import "./ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";
const GCLandedCost = ({
  open,
  onClose,
  xTitle = "",
  xClose,
  xSave,
  xLoaded_Cost_GRNType = "",
  xLoaded_Cost_GRNNo = "",
  xLoaded_Cost_Freight = "",
  xLoaded_Cost_Customs = "",
  xLoaded_Cost_Discount = "",
  xLoaded_Cost_DiscAmt = "",
  //Loaded_Cost
  xLoaded_Cost_AccountArr = [],
  xLoaded_Cost_Obj,
  xLandedCostObjError,
  xLoaded_Cost_ToggleArr = [],
  //Freight
  xfLoaded_Cost_Freight_Acc,
  xfLoaded_Cost_Freight_Name,
  xLoaded_Cost_Freight_Toggle = false,
  xLoaded_Cost_Freight_onKeyUp,
  xLoaded_Cost_Freight_SearchDropdownObj,
  xLoaded_Cost_Freight_Dropdown_onChange,
  xLoaded_Cost_Freight_Dropdown_OnKeyUp_Load,
  xLoaded_Cost_Freight_Columns_DropdownSearch,
  xLoaded_Cost_Freight_GridData,
  xfLoaded_Cost_Freight__OnRowClick,
  xfLoaded_Cost_Freight_OnCellKeyDown,
  //customs
  xfLoaded_Cost_Customs_Acc,
  xfLoaded_Cost_Customs_Name,
  xLoaded_Cost_Customs_Toggle = false,
  xLoaded_Cost_Customs_onKeyUp,
  xLoaded_Cost_Customs_SearchDropdownObj,
  xLoaded_Cost_Customs_Dropdown_onChange,
  xLoaded_Cost_Customs_Dropdown_OnKeyUp_Load,
  xLoaded_Cost_Customs_Columns_DropdownSearch,
  xLoaded_Cost_Customs_GridData,
  xfLoaded_Cost_Customs__OnRowClick,
  xfLoaded_Cost_Customs_OnCellKeyDown,
  //discount
  xfLoaded_Cost_Discount_Name,
  xLoaded_Cost_Discount_Toggle = false,
  xLoaded_Cost_Discount_onKeyUp,
  xLoaded_Cost_Discount_SearchDropdownObj,
  xLoaded_Cost_Discount_Dropdown_onChange,
  xLoaded_Cost_Discount_Dropdown_OnKeyUp_Load,
  xLoaded_Cost_Discount_Columns_DropdownSearch,
  xLoaded_Cost_Discount_GridData,
  xfLoaded_Cost_Discount__OnRowClick,
  xfLoaded_Cost_Discount_OnCellKeyDown,
  //splDiscount
  xfLoaded_Cost_SplDiscount_Name,
  xLoaded_Cost_SplDiscount_Toggle = false,
  xLoaded_Cost_SplDiscount_onKeyUp,
  xLoaded_Cost_SplDiscount_SearchDropdownObj,
  xLoaded_Cost_SplDiscount_Dropdown_onChange,
  xLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load,
  xLoaded_Cost_SplDiscount_Columns_DropdownSearch,
  xLoaded_Cost_SplDiscount_GridData,
  xfLoaded_Cost_SplDiscount__OnRowClick,
  xfLoaded_Cost_SplDiscount_OnCellKeyDown,
  fCustomer,
  fFreight
}) => {
  const vMediaQuery = useMediaQuery("(max-width:850px)");
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ overflow: "auto" }} className="model-gc-freight">
      <GCTitleSticky
        title={xTitle}
        onClose={xClose}
        />
      
        {/* <Grid
        container
        spacing={1}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className="GCbatch-m"
      >
        <Grid item xs={11} sm={11} md={11} lg={11}>
          <CmpTypographyField
            xcomponent={"h1"}
            xText={xTitle}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1} className="text-end">
          <CmpButtonKIcon
            xOnClick={!!xClose ? xClose : fDummyFunction}
            xDisabled={false}
            xIcon={<CloseIcon fontSize={"medium"} />}
          />
        </Grid>
      </Grid> */}
        <div className={vMediaQuery ? "px-2 " : "px-2 py-4"}>
          <Grid
            container
            spacing={0}
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className="GCbatch-m"
          >
            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={3} sm={2} md={1} lg={1.5}>
                  <CmpTypographyField xcomponent={"h1"} xText={"GRN Type"} />
                </Grid>
                <Grid item xs={6} sm={4} md={2} lg={2}>
                  <CmpInputField
                    xValue={xLoaded_Cost_GRNType}
                    xType={"text"} // text/number/password
                    xName={"xLoaded_GRNType"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={3} sm={2} md={1} lg={1.5}>
                  <CmpTypographyField xcomponent={"h1"} xText={"GRN No"} />
                </Grid>
                <Grid item xs={6} sm={4} md={2} lg={2}>
                  <CmpInputField
                    xValue={xLoaded_Cost_GRNNo}
                    xType={"text"} // text/number/password
                    xName={"xLoaded_Cost_GRNNo"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={3} sm={2} md={1} lg={1.5}>
                  <CmpTypographyField xcomponent={"h1"} xText={"GRN No"} />
                </Grid>
                <Grid item xs={6} sm={4} md={2} lg={2}>
                  <CmpInputField
                    xValue={xLoaded_Cost_GRNNo}
                    xType={"text"} // text/number/password
                    xName={"xLoaded_Cost_GRNNo"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                spacing={0}
                columnSpacing={{ xs: 0, sm: 0, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={3} sm={2} md={1} lg={1.5}>
                  <CmpTypographyField xcomponent={"h1"} xText={"Freight"} />
                </Grid>
                <Grid item xs={3} sm={4} md={2} lg={1.5}>
                  <CmpInputField
                    xValue={xLoaded_Cost_Freight}
                    xType={"number"} // text/number/password
                    xName={"xLoaded_Cost_Freight"}
                    xReadOnly={false}
                    xOnChange={fFreight}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={3} sm={2} md={1} lg={1.5}>
                  <CmpTypographyField xcomponent={"h1"} xText={"Customs"} />
                </Grid>
                <Grid item xs={3} sm={4} md={2} lg={1.5}>
                  <CmpInputField
                    xValue={xLoaded_Cost_Customs}
                    xType={"number"} // text/number/password
                    xName={"xLoaded_Cost_Customs"}
                    xReadOnly={false}
                    xOnChange={fCustomer}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={3} sm={2} md={1} lg={1.5}>
                  <CmpTypographyField xcomponent={"h1"} xText={"Discount"} />
                </Grid>
                <Grid item xs={3} sm={4} md={2} lg={1.5}>
                  <CmpInputField
                    xValue={xLoaded_Cost_Discount}
                    xType={"number"} // text/number/password
                    xName={"xLoaded_Cost_Discount"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={3} sm={2} md={1} lg={1.5}>
                  <CmpTypographyField xcomponent={"h1"} xText={"Spl Disc"} />
                </Grid>
                <Grid item xs={3} sm={4} md={2} lg={1.5}>
                  <CmpInputField
                    xValue={xLoaded_Cost_DiscAmt}
                    xType={"number"} // text/number/password
                    xName={"xLoaded_Cost_DiscAmt"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={11} sm={11} md={11} lg={11}>
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Freight"}
                    xfontSize="20px"
                    xtextDecoration="underline"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid
                  item
                  xs={12}
                  sm={2}
                  md={"auto"}
                  lg={"auto"}
                  className="pe-1"
                >
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Account Name"}
                  />
                </Grid>
                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpSelectArrField
                    xLabelText="xFreightAccount"
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Freight_Acc}
                    xOnChange={
                      !!xfLoaded_Cost_Freight_Acc
                        ? xfLoaded_Cost_Freight_Acc
                        : fDummyFunction
                    }
                    xName={"Loaded_Cost_Freight_Acc"}
                    xData={xLoaded_Cost_AccountArr}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={
                      xLandedCostObjError.Loaded_Cost_Freight_Acc === ""
                        ? false
                        : true
                    }
                    xErrorMessage={xLandedCostObjError.Loaded_Cost_Freight_Acc}
                    xDisable={false}
                    xtabIndex="2001"
                  />
                </Grid>
                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpInputField
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Freight_Code}
                    xType={"text"} // text/number/password
                    xName={"Loaded_Cost_Freight_Code"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={
                      xLandedCostObjError.Loaded_Cost_Freight_Code === ""
                        ? false
                        : true
                    }
                    xErrorMessage={xLandedCostObjError.Loaded_Cost_Freight_Code}
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={5}>
                  <GCToggleSearch
                    xName={"Loaded_Cost_Freight_Name"}
                    xType={"text"}
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Freight_Name}
                    xReadOnly={false}
                    xOnChange={xfLoaded_Cost_Freight_Name} //GCToggleSearch onchange main input
                    xOnKeyUp={xLoaded_Cost_Freight_onKeyUp} //GCToggleSearch xOnKeyUp main input
                    xError={
                      xLandedCostObjError.Loaded_Cost_Freight_Name === ""
                        ? false
                        : true
                    }
                    xErrorMessage={xLandedCostObjError.Loaded_Cost_Freight_Name}
                    xMediaQuery={false}
                    xonClickbtn={xLoaded_Cost_Freight_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                    xrows={xLoaded_Cost_Freight_GridData} //GCToggleSearch-grid
                    xcolumns={xLoaded_Cost_Freight_Columns_DropdownSearch} //GCToggleSearch-grid
                    xRowCellClick={xfLoaded_Cost_Freight_OnCellKeyDown}
                    xRowClick={xfLoaded_Cost_Freight__OnRowClick}
                    xToggle={xLoaded_Cost_Freight_Toggle} //GCToggleSearch- true/false
                    xData={xLoaded_Cost_ToggleArr} //GCToggleSearch-select
                    xOnChangeDropdownInput={
                      xLoaded_Cost_Freight_Dropdown_onChange
                    } //GCToggleSearch -input
                    xDropdownObj={xLoaded_Cost_Freight_SearchDropdownObj} //GCToggleSearch -obj
                    xOnKeyUpDropdownInput={
                      xLoaded_Cost_Freight_Dropdown_OnKeyUp_Load
                    } //GCToggleSearch -Enter key and clickc detect
                    xtabIndex="2002"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={11} sm={11} md={11} lg={11}>
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Customs"}
                    xfontSize="20px"
                    xtextDecoration="underline"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid
                  item
                  xs={12}
                  sm={2}
                  md={"auto"}
                  lg={"auto"}
                  className="pe-1"
                >
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Account Name"}
                  />
                </Grid>
                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpSelectArrField
                    xLabelText="xFreightAccount"
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Customs_Acc}
                    xOnChange={
                      !!xfLoaded_Cost_Customs_Acc
                        ? xfLoaded_Cost_Customs_Acc
                        : fDummyFunction
                    }
                    xName={"Loaded_Cost_Customs_Acc"}
                    xData={xLoaded_Cost_AccountArr}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={
                      xLandedCostObjError.Loaded_Cost_Customs_Acc === ""
                        ? false
                        : true
                    }
                    xErrorMessage={xLandedCostObjError.Loaded_Cost_Customs_Acc}
                    xDisable={false}
                    xtabIndex="2003"
                  />
                </Grid>
                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpInputField
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Customs_Code}
                    xType={"text"} // text/number/password
                    xName={"Loaded_Cost_Customs_Code"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={
                      xLandedCostObjError.Loaded_Cost_Customs_Code === ""
                        ? false
                        : true
                    }
                    xErrorMessage={xLandedCostObjError.Loaded_Cost_Customs_Code}
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={5}>
                  <GCToggleSearch
                    xName={"Loaded_Cost_Customs_Name"}
                    xType={"text"}
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Customs_Name}
                    xReadOnly={false}
                    xOnChange={xfLoaded_Cost_Customs_Name} //GCToggleSearch onchange main input
                    xOnKeyUp={xLoaded_Cost_Customs_onKeyUp} //GCToggleSearch xOnKeyUp main input
                    xError={
                      xLandedCostObjError.Loaded_Cost_Customs_Name === ""
                        ? false
                        : true
                    }
                    xErrorMessage={xLandedCostObjError.Loaded_Cost_Customs_Name}
                    xMediaQuery={false}
                    xonClickbtn={xLoaded_Cost_Customs_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                    xrows={xLoaded_Cost_Customs_GridData} //GCToggleSearch-grid
                    xcolumns={xLoaded_Cost_Customs_Columns_DropdownSearch} //GCToggleSearch-grid
                    xRowCellClick={xfLoaded_Cost_Customs_OnCellKeyDown}
                    xRowClick={xfLoaded_Cost_Customs__OnRowClick}
                    xToggle={xLoaded_Cost_Customs_Toggle} //GCToggleSearch- true/false
                    xData={xLoaded_Cost_ToggleArr} //GCToggleSearch-select
                    xOnChangeDropdownInput={
                      xLoaded_Cost_Customs_Dropdown_onChange
                    } //GCToggleSearch -input
                    xDropdownObj={xLoaded_Cost_Customs_SearchDropdownObj} //GCToggleSearch -obj
                    xOnKeyUpDropdownInput={
                      xLoaded_Cost_Customs_Dropdown_OnKeyUp_Load
                    } //GCToggleSearch -Enter key and clickc detect
                    xtabIndex="2004"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={11} sm={11} md={11} lg={11}>
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Discount"}
                    xfontSize="20px"
                    xtextDecoration="underline"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid
                  item
                  xs={12}
                  sm={2}
                  md={"auto"}
                  lg={"auto"}
                  className="pe-1"
                >
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Account Name"}
                  />
                </Grid>
                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpInputField
                    xValue={""}
                    xType={"text"} // text/number/password
                    xName={""}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpInputField
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Discount_Code}
                    xType={"text"} // text/number/password
                    xName={"Loaded_Cost_Discount_Code"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={
                      xLandedCostObjError.Loaded_Cost_Discount_Code === ""
                        ? false
                        : true
                    }
                    xErrorMessage={
                      xLandedCostObjError.Loaded_Cost_Discount_Code
                    }
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={5}>
                  <GCToggleSearch
                    xName={"Loaded_Cost_Discount_Name"}
                    xType={"text"}
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_Discount_Name}
                    xReadOnly={false}
                    xOnChange={xfLoaded_Cost_Discount_Name} //GCToggleSearch onchange main input
                    xOnKeyUp={xLoaded_Cost_Discount_onKeyUp} //GCToggleSearch xOnKeyUp main input
                    xError={
                      xLandedCostObjError.Loaded_Cost_Discount_Name === ""
                        ? false
                        : true
                    }
                    xErrorMessage={
                      xLandedCostObjError.Loaded_Cost_Discount_Name
                    }
                    xMediaQuery={false}
                    xonClickbtn={xLoaded_Cost_Discount_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                    xrows={xLoaded_Cost_Discount_GridData} //GCToggleSearch-grid
                    xcolumns={xLoaded_Cost_Discount_Columns_DropdownSearch} //GCToggleSearch-grid
                    xRowCellClick={xfLoaded_Cost_Discount_OnCellKeyDown}
                    xRowClick={xfLoaded_Cost_Discount__OnRowClick}
                    xToggle={xLoaded_Cost_Discount_Toggle} //GCToggleSearch- true/false
                    xData={xLoaded_Cost_ToggleArr} //GCToggleSearch-select
                    xOnChangeDropdownInput={
                      xLoaded_Cost_Discount_Dropdown_onChange
                    } //GCToggleSearch -input
                    xDropdownObj={xLoaded_Cost_Discount_SearchDropdownObj} //GCToggleSearch -obj
                    xOnKeyUpDropdownInput={
                      xLoaded_Cost_Discount_Dropdown_OnKeyUp_Load
                    } //GCToggleSearch -Enter key and clickc detect
                    xtabIndex="2006"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid item xs={11} sm={11} md={11} lg={11}>
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Special Discount"}
                    xfontSize="20px"
                    xtextDecoration="underline"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
              >
                <Grid
                  item
                  xs={12}
                  sm={2}
                  md={"auto"}
                  lg={"auto"}
                  className="pe-1"
                >
                  <CmpTypographyField
                    xcomponent={"h1"}
                    xText={"Account Name"}
                  />
                </Grid>

                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpInputField
                    xValue={""}
                    xType={"text"} // text/number/password
                    xName={""}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={false}
                    xErrorMessage={""}
                    xOnKeyUp={""}
                  />
                </Grid>
                <Grid item xs={6} sm={2} md={1.5} lg={2}>
                  <CmpInputField
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_SplDiscount_Code}
                    xType={"text"} // text/number/password
                    xName={"Loaded_Cost_SplDiscount_Code"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={
                      xLandedCostObjError.Loaded_Cost_SplDiscount_Code === ""
                        ? false
                        : true
                    }
                    xErrorMessage={
                      xLandedCostObjError.Loaded_Cost_SplDiscount_Code
                    }
                    xOnKeyUp={""}
                    textAlign={"right"}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={5}>
                  <GCToggleSearch
                    xName={"Loaded_Cost_SplDiscount_Name"}
                    xType={"text"}
                    xValue={xLoaded_Cost_Obj.Loaded_Cost_SplDiscount_Name}
                    xReadOnly={false}
                    xOnChange={xfLoaded_Cost_SplDiscount_Name} //GCToggleSearch onchange main input
                    xOnKeyUp={xLoaded_Cost_SplDiscount_onKeyUp} //GCToggleSearch xOnKeyUp main input
                    xError={
                      xLandedCostObjError.Loaded_Cost_SplDiscount_Name === ""
                        ? false
                        : true
                    }
                    xErrorMessage={
                      xLandedCostObjError.Loaded_Cost_SplDiscount_Name
                    }
                    xMediaQuery={false}
                    xonClickbtn={xLoaded_Cost_SplDiscount_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                    xrows={xLoaded_Cost_SplDiscount_GridData} //GCToggleSearch-grid
                    xcolumns={xLoaded_Cost_SplDiscount_Columns_DropdownSearch} //GCToggleSearch-grid
                    xRowCellClick={xfLoaded_Cost_SplDiscount_OnCellKeyDown}
                    xRowClick={xfLoaded_Cost_SplDiscount__OnRowClick}
                    xToggle={xLoaded_Cost_SplDiscount_Toggle} //GCToggleSearch- true/false
                    xData={xLoaded_Cost_ToggleArr} //GCToggleSearch-select
                    xOnChangeDropdownInput={
                      xLoaded_Cost_SplDiscount_Dropdown_onChange
                    } //GCToggleSearch -input
                    xDropdownObj={xLoaded_Cost_SplDiscount_SearchDropdownObj} //GCToggleSearch -obj
                    xOnKeyUpDropdownInput={
                      xLoaded_Cost_SplDiscount_Dropdown_OnKeyUp_Load
                    } //GCToggleSearch -Enter key and clickc detect
                    xtabIndex="2008"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid
                container
                spacing={0}
                columnSpacing={{ xs: 1, sm: 1, md: 1 }}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className="GCbatch-m"
                justifyContent={"center"}
                alignItems="center"
              >
                <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={!!xSave ? xSave : fDummyFunction}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={"auto"} sm={"auto"} md={"auto"} lg={"auto"}>
                  <CmpButton
                    xbtnName="Close"
                    xOnClick={!!xClose ? xClose : fDummyFunction}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default GCLandedCost;
